var React = require('react');

function Arrow2white (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.9016 2.29919L23.6258 12.2133L13.9016 21.9453","stroke":"white","strokeWidth":"2.5","key":0}),React.createElement("path",{"d":"M22.6677 12.122L0.302088 12.122","stroke":"white","strokeWidth":"2.5","key":1})]);
}

Arrow2white.defaultProps = {"width":"27","height":"24","viewBox":"0 0 27 24","fill":"none"};

module.exports = Arrow2white;

Arrow2white.default = Arrow2white;
